import * as Yup from "yup";

import { getInjuriesSchema } from "Components/Form/RecentDamages/validation";
import { TextManager } from "Components/TextContext";
import { isWholeThousand } from "Utils/numberUtils";
import { TrailerProductDetailsFormValues } from "../trailerInterface";

const MIN_INSURANCE_SUM = 1000;
const MAX_INSURANCE_SUM = 99000;

export const validationSchema =
  (): Yup.ObjectSchema<TrailerProductDetailsFormValues> => {
    const { getText } = TextManager;

    return Yup.object()
      .shape({
        coverageAmount: Yup.number()
          .required(getText("trailerform.validation.coverageamount_required"))
          .min(
            MIN_INSURANCE_SUM,
            getText("trailerform.validation.coverageamount_invalid"),
          )
          .max(
            MAX_INSURANCE_SUM,
            getText("trailerform.validation.coverageamount_invalid"),
          )
          .test({
            name: "is-whole-thousand",
            message: getText("trailerform.validation.coverageamount_notwhole"),
            test: isWholeThousand,
          }),
      })
      .concat(getInjuriesSchema());
  };
